import React from 'react'

interface ProcessingModalProps {
  isVisible: boolean
  title: string
  message: string
  primaryColor?: string
}

/**
 * Standardized processing modal component for consistent loading states across all pages.
 * 
 * Usage:
 * ```tsx
 * <ProcessingModal
 *   isVisible={isProcessing}
 *   title="Processing..."
 *   message="Please wait while we process your photos"
 *   primaryColor={primaryColor}
 * />
 * ```
 */
const ProcessingModal: React.FC<ProcessingModalProps> = ({
  isVisible,
  title,
  message,
  primaryColor = '#3B82F6' // Default blue color
}) => {
  if (!isVisible) return null

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center bg-black/50 p-5 backdrop-blur-sm sm:p-8">
      <div className="w-full max-w-md rounded-2xl bg-white/95 p-6 shadow-2xl sm:p-8">
        <div className="text-center">
          <div
            className="mx-auto mb-4 h-16 w-16 animate-spin rounded-full border-4 border-t-transparent"
            style={{
              borderColor: primaryColor,
              borderTopColor: 'transparent'
            }}
          />
          <h2 className="mb-2 text-xl font-bold text-gray-800 sm:text-2xl">{title}</h2>
          <p className="text-sm text-gray-600 sm:text-base">{message}</p>
        </div>
      </div>
    </div>
  )
}

export default ProcessingModal

